import { GlobalContext, Section } from "../lib/Root";
import { useContext, useEffect } from "react";

export default function Profile() {
	var _ = useContext(GlobalContext);
	useEffect(() => { _.document.title = "Profile"; }, []);

	return <Section center>
		<p>Your profile is currently under construction.</p>
	</Section>;
}